import {
    confirmSignIn as confirmSignInService,
    getUserData,
    refreshTokens,
    resendSmsOtp,
} from '../../../services';

import AmplifyActions from '/b2b/authentication/state/amplify/Amplify.actions';
import AuthActions from '/b2b/authentication/state/Auth.actions';
import { shouldRefreshTokens } from '/b2b/authentication/state/Auth.selectors';

export const confirmSignIn = params => (dispatch, getState) => {
    dispatch(AuthActions.confirmSignInBegin(params));

    const { code, mfaType } = params;
    return confirmSignInService({
        challengeResponse: code,
        options: {
            // userAttributes,
            // friendlyDeviceName,
            // clientMetadata,
        },
    })
        .then(async confirmSignInOutput => {
            switch (confirmSignInOutput.nextStep.signInStep) {
                case 'DONE': {
                    // User is signed in and we need a token refresh to get them into Redux
                    const session = await refreshTokens();
                    shouldRefreshTokens(getState(), session) &&
                        dispatch(AuthActions.refreshTokens(session.tokens));
                    break;
                }
            }
            dispatch(AuthActions.confirmSignInSuccess(params, confirmSignInOutput));
            dispatch(AmplifyActions.nextStep(confirmSignInOutput));
            return getUserData().then(currentUser => {
                dispatch(AmplifyActions.getUserDataSuccess(currentUser));
                return currentUser;
            });
        })
        .catch(error => {
            const { message, name } = error;
            switch (name) {
                case 'ExpiredCodeException': {
                    // This can happen if you sign in and out too quickly, and you reuse the same code
                    switch (mfaType) {
                        case 'SMS':
                            // You need to request a new code, or wait for the new code to arrive
                            break;
                        case 'TOTP':
                            // Your TOTP token needs to refresh. Wait for the token to cycle
                            break;
                    }
                }
            }
            dispatch(AuthActions.confirmSignInFailure(params, error));

            throw message;
        });
};

export const resendCode = mfaType => dispatch => {
    dispatch(AuthActions.resendCodeBegin(mfaType));

    switch (mfaType) {
        case 'SMS': {
            return resendSmsOtp()
                .then(response => {
                    dispatch(AmplifyActions.nextStep(response));
                    dispatch(AuthActions.resendCodeSuccess(mfaType, response));
                })
                .catch(error => {
                    const { message } = error;
                    dispatch(AuthActions.resendCodeFailure(mfaType, error));

                    throw message;
                });
        }
    }

    return Promise.reject(new Error(`Unsupported MFA type: ${mfaType}`));
};

export const signOut = () => dispatch => {
    dispatch(AuthActions.logout());
};
